import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import Papa from 'papaparse'
import FormData from 'form-data'
import {Button} from "react-bootstrap";
import {BulkImportAction} from "../../../../../api/omnimap/omnimapActions";

class CreateManagementUnit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            csvFile: undefined
        };
        this.baseState = this.state;
        this.updateData = this.updateData.bind(this);
    }

    handleChange = event => {
        this.setState({
            csvFile: event.target.files[0]
        });
    };

    importCSV = () => {
        const {csvFile} = this.state;
        Papa.parse(csvFile, {
            complete: this.updateData,
            header: true
        });
    };

    updateData(result) {
        const data = result.data;

        const spin = $("#cover-spin");

        spin.show(0);
        const model = new FormData();

        model.append('template_identification', window.$template_identification);
        model.append('csv', this.state.csvFile)

        if (this.isCsvEligible(data)) {
            omnimap.BulkImportAction(model).then(() => {
                $("#bulk-import-modal").modal("hide");
                spin.hide(0);
            }).catch((e) => {
                alert(JSON.stringify(e));
                spin.hide(0);
            }).finally(() => spin.hide(0))
        } else {
            alert('CSV Integrity Check Failed!');
            spin.hide(0);
        }

    }

    isCsvEligible(data) {
        const columns = [
            "Code",
            "Latijnse naam",
            "Nederlandse naam",
            "Soort",
            "Start periode",
            "Eind periode",
            "Wet",
            "Lijst",
            "Naam periode",
            "Opmerking"
        ]
        const a = (data.length <= 0) ? false : columns.length === Object.keys(data[0]).length
        return a;
    }

    async componentDidMount() {

        $(document).on("click", "#bulk-import", function () {
            $("#bulk-import-modal").modal("show");
            CommonFunctions.GetColumnProperties("create");

            // that.resetForm();
        });
    }

    render() {
        return (
            <div
                className="modal fade"
                tabIndex={-1}
                role="dialog"
                id="bulk-import-modal"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Bulk import</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div
                            className="modal-body"
                        >
                            <div className="center-flex">
                                <h3 className="text">Selecteer een csv bestand voor de import</h3>
                            </div>
                            <div className="center-flex">
                                <input
                                    className="box-file-input"
                                    type="file"
                                    ref={input => {
                                        this.filesInput = input;
                                    }}
                                    name="file"
                                    accept=".csv"
                                    placeholder={null}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <p/>

                            <br/>
                            <br/>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn-modal"
                                onClick={this.importCSV}
                            >
                                Verwerken
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateManagementUnit;
